import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input } from "@angular/core";
import { LANGUAGE_ENUM } from "../../dateneingabe-frageboge/questionnaire.model";

@Component({
    selector: 'app-datenubersicht-info',
    templateUrl: "./datenubersicht-info.component.html",
    styleUrls: ["./datenubersicht-info.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DatenubersichtInfoComponent implements OnInit {
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    LANGUAGE_ENUM = LANGUAGE_ENUM;
   
    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

}
